import { apiCall, escalateError, getResponseData } from './index';

export default class CallsApi {
  static generateCall(data) {
    return apiCall.post('dialer/dialV2', data)
      .then(getResponseData)
      .catch(escalateError);
  }
}
